import FilterAudio from './FilterAudio'

export default FilterAudio
